import React, { Component } from "react";
import "./alumni-employment-status.css";

export default class AlumniEmploymentStatus extends Component {
  render() {
    return (
      <div className="mitable">
        <table>
          <caption></caption>
          <thead></thead>
          <tbody>
            <tr
              style={{
                backgroundColor: "#270733",
                color: "#fff",
              }}
            >
              <th
                style={{
                  textAlign: "center",
                }}
              >
                生活科技學院
              </th>
              <th
                style={{
                  textAlign: "center",
                }}
              >
                管理學院
              </th>
              <th
                style={{
                  textAlign: "center",
                }}
              >
                設計學院
              </th>
              <th
                style={{
                  textAlign: "center",
                }}
              >
                藝術學院
              </th>
              <th
                style={{
                  textAlign: "center",
                }}
              >
                旅遊學院
              </th>
              <th
                style={{
                  textAlign: "center",
                }}
              >
                師資培育中心
              </th>
            </tr>
            <tr>
              <td>
                <a
                  href="https://guide.104.com.tw/career/schoolMajor/5103000000/810801/further/?exp=2"
                  target="_blank"
                  rel="noreferrer"
                >
                  美容造型設計系
                </a>
              </td>
              <td>
                <a
                  href="https://guide.104.com.tw/career/schoolMajor/5103000000/340501/further/?exp=2"
                  target="_blank"
                  rel="noreferrer"
                >
                  財務金融系
                </a>
              </td>
              <td>
                <a
                  href="https://guide.104.com.tw/career/schoolMajor/5103000000/230201/further/?exp=2"
                  target="_blank"
                  rel="noreferrer"
                >
                  視覺傳達設計系所
                </a>
              </td>
              <td>音樂系所</td>
              <td>
                <a
                  href="https://guide.104.com.tw/career/schoolMajor/5103000000/810101/further/?exp=2"
                  target="_blank"
                  rel="noreferrer"
                >
                  旅館管理系
                </a>
              </td>
              <td></td>
            </tr>
            <tr>
              <td>
                <a
                  href="https://guide.104.com.tw/career/schoolMajor/5103000000/810109/further/?exp=2"
                  target="_blank"
                  rel="noreferrer"
                >
                  餐飲系
                </a>
              </td>
              <td>
                <a
                  href="https://guide.104.com.tw/career/schoolMajor/5103000000/340301/further/?exp=2"
                  target="_blank"
                  rel="noreferrer"
                >
                  企業管理系
                </a>
              </td>
              <td>
                <a
                  href="https://guide.104.com.tw/career/schoolMajor/5103000000/230208/further/?exp=2"
                  target="_blank"
                  rel="noreferrer"
                >
                  多媒體動畫系
                </a>
              </td>
              <td>
                <a
                  href="https://guide.104.com.tw/career/schoolMajor/5103000000/210415/further/?exp=2"
                  target="_blank"
                  rel="noreferrer"
                >
                  流行音樂系
                </a>
              </td>
              <td>餐旅管理學士學位學程</td>
              <td></td>
            </tr>
            <tr>
              <td>
                <a
                  href="https://guide.104.com.tw/career/schoolMajor/5103000000/810527/further/?exp=2"
                  target="_blank"
                  rel="noreferrer"
                >
                  運動休閒與健康管理系
                </a>
              </td>
              <td>
                <a
                  href="https://guide.104.com.tw/career/schoolMajor/5103000000/340309/further/?exp=2"
                  target="_blank"
                  rel="noreferrer"
                >
                  國際企業經營系所
                </a>
              </td>
              <td>漫畫系</td>
              <td>
                <a
                  href="https://guide.104.com.tw/career/schoolMajor/5103000000/210101/further/?exp=2"
                  target="_blank"
                  rel="noreferrer"
                >
                  美術系所
                </a>
              </td>
              <td>
                <a
                  href="https://guide.104.com.tw/career/schoolMajor/5103000000/220312/further/?exp=2"
                  target="_blank"
                  rel="noreferrer"
                >
                  應用英語系
                </a>
              </td>
              <td></td>
            </tr>
            <tr>
              <td>
                <a
                  href="https://guide.104.com.tw/career/schoolMajor/5103000000/810704/further/?exp=2"
                  target="_blank"
                  rel="noreferrer"
                >
                  服飾設計管理系
                </a>
              </td>
              <td>
                <a
                  href="https://guide.104.com.tw/career/schoolMajor/5103000000/480109/further/?exp=2"
                  target="_blank"
                  rel="noreferrer"
                >
                  資訊管理系
                </a>
              </td>
              <td>
                <a
                  href="https://guide.104.com.tw/career/schoolMajor/5103000000/230401/further/?exp=2"
                  target="_blank"
                  rel="noreferrer"
                >
                  室內設計系所
                </a>
              </td>
              <td>
                <a
                  href="https://guide.104.com.tw/career/schoolMajor/5103000000/210511/further/?exp=2"
                  target="_blank"
                  rel="noreferrer"
                >
                  舞蹈系
                </a>
              </td>
              <td>會計資訊系</td>
              <td></td>
            </tr>
            <tr>
              <td>
                <a
                  href="https://guide.104.com.tw/career/schoolMajor/5103000000/760401/further/?exp=2"
                  target="_blank"
                  rel="noreferrer"
                >
                  幼兒保育系
                </a>
              </td>
              <td>連鎖加盟經營管理學士學位學程</td>
              <td>
                <a
                  href="https://guide.104.com.tw/career/schoolMajor/5103000000/230307/further/?exp=2"
                  target="_blank"
                  rel="noreferrer"
                >
                  商品設計系
                </a>
              </td>
              <td>
                <a
                  href="https://guide.104.com.tw/career/schoolMajor/5103000000/810534/further/?exp=2"
                  target="_blank"
                  rel="noreferrer"
                >
                  養生休閒管理系
                </a>
              </td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>
                <a
                  href="https://guide.104.com.tw/career/schoolMajor/5103000000/810605/further/?exp=2"
                  target="_blank"
                  rel="noreferrer"
                >
                  生活服務產業系所
                </a>
              </td>
              <td></td>
              <td>
                <a
                  href="https://guide.104.com.tw/career/schoolMajor/5103000000/230104/further/?exp=2"
                  target="_blank"
                  rel="noreferrer"
                >
                  時尚設計系
                </a>
              </td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td>備註</td>
              <td colSpan="5">
                相關數據統計，來自
                <a
                  href="https://guide.104.com.tw/career/school/5103000000/"
                  target="_blank"
                  rel="noreferrer"
                >
                  104升學就業地圖
                </a>
                僅供參考
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    );
  }
}
